import React, { useState } from "react";
import { ReactComponent as ApprovedIcon } from "../../../Assets/Icons/approveIcon.svg";
import { ReactComponent as DeclinedIcon } from "../../../Assets/Icons/declinedIcon.svg";
import { ReactComponent as PendingIcon } from "../../../Assets/Icons/pendingIcon.svg";
import { ReactComponent as DraftedIcon } from "../../../Assets/Icons/draftedIcon.svg";
import { ReactComponent as HourglassIcon } from "../../../Assets/Icons/hourglass.svg";

// Keep the same props signature to avoid breaking callers, but ignore extras
// enablePendingAction controls whether clicking Approved/Declined reveals a Pending action (Admin only)
const Confirmation = ({ status, onStatusClick, offerId, enablePendingAction = false, creatorRole = "", showInProcess = true }) => {
  const [isSelected, setIsSelected] = useState(false);

  // Normalize status to lowercase for consistent comparison
  const normalizedStatus = status?.toLowerCase();

  const handlePendingClick = () => {
    if (onStatusClick) {
      onStatusClick(offerId, "pending");
      setIsSelected(false); // Reset selection after status change
    }
  };

  if (normalizedStatus === "approved") {
    // Approved status should be completely static - no interactions
    return (
      <div className="flex items-center gap-2">
        <ApprovedIcon />
      </div>
    );
  }

  // Handle all incomplete statuses (Draft/In-Process variants)
  const inProcessVariants = ["in-process", "in progress", "in-progress", "in process"];
  const draftedVariants = ["draft", "drafted"];

  if (inProcessVariants.includes(normalizedStatus) || (draftedVariants.includes(normalizedStatus) && showInProcess && creatorRole?.toLowerCase() === "merchant")) {
    return (
      <div
        className="flex items-center justify-center gap-1 w-[110px] h-[25px] rounded-[20px]"
        style={{
          background: "#FFF1D6",
          border: "0.5px solid #FFC961"
        }}
      >
        <HourglassIcon className="w-3 h-3" style={{ color: "#8F6828" }} />
        <p className="text-[12px] font-[400]" style={{ color: "#8F6828" }}>In-Process</p>
      </div>
    );
  }

  if (draftedVariants.includes(normalizedStatus)) {
    return (
      <div className="flex items-center gap-2">
        <DraftedIcon />
      </div>
    );
  }

  if (normalizedStatus === "draft" || normalizedStatus === "drafted") {
    return (
      <div className="flex items-center gap-2">
        <DraftedIcon />
      </div>
    );
  }

  if (normalizedStatus === "declined" || normalizedStatus === "rejected") {
    if (!enablePendingAction) {
      return (
        <div className="flex items-center gap-2">
          <DeclinedIcon />
        </div>
      );
    }
    if (isSelected) {
      return (
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-2 bg-blue-100 px-2 py-1 rounded-md">
            <span className="text-xs text-blue-600 font-medium">Selected</span>
            <button
              onClick={handlePendingClick}
              className="bg-blue-600 text-white text-xs px-2 py-1 rounded hover:bg-blue-700 transition-colors"
            >
              Pending
            </button>
            <button
              onClick={() => setIsSelected(false)}
              className="text-blue-600 hover:text-blue-800 text-xs font-bold"
            >
              ×
            </button>
          </div>
        </div>
      );
    }

    return (
      <div
        className="flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity"
        onClick={() => setIsSelected(true)}
        title="Click to select"
      >
        <DeclinedIcon />
      </div>
    );
  }

  if (normalizedStatus === "pending") {
    return (
      <div className="flex items-center gap-2">
        <PendingIcon />
      </div>
    );
  }

  return null;
};

export default Confirmation;
